const prefix = "PROVIDER_CONTACT_";

export const LIST = prefix + "LIST";
export const FLAG_AS_PRIMARY = prefix + "FLAG_AS_PRIMARY";
export const GET = prefix + "GET";
export const SET_STATUS_SAVE = prefix + "SET_STATUS_SAVE";
